// extracted by css-extract-rspack-plugin
export default {"tip":"tip--iyYGN2nO7t0mbJos","tipAlternativePosition":"tip-alternative-position--JD63wM70RM4JCcNG"};